import React from 'react';

interface Props {
  label: string;
  onClick: () => void;
}

export const SectionFooterLink: React.FC<Props> = ({ label, onClick }) => (
  <div className="border-t border-border px-4 py-4">
    <button
      type="button"
      onClick={onClick}
      className="mx-auto flex cursor-pointer items-center px-2 py-1 text-body-13 font-semibold text-primary"
    >
      {label}
    </button>
  </div>
);
